/*       */

import { graphql } from 'graphql/client';
import { loadData } from 'app/utils/redux/action-utils';
import { get } from 'app/utils/lo/lo';
import { addRoleToData } from 'app/config/rolesConfig';

import userByReferenceQuery from 'graphql/app/userByReferenceQuery';
import userChangelogQuery from 'graphql/users/userChangelogQuery';
import loadUserWorkspacesQuery from 'graphql/workspaces/loadUserWorkspacesQuery';
import loadUserAboutWorkspacesQuery from 'graphql/workspaces/loadUserAboutWorkspacesQuery';
import { buildUserWorkspaceFilter } from 'app/utils/filter/filterUtils';

export const LOAD_USER_STARTED = '@@affectli/admin/users/LOAD_USER_STARTED';
export const LOAD_USER = '@@affectli/admin/users/LOAD_USER';

export const LOAD_ROLE_STARTED = '@@affectli/admin/users/LOAD_ROLE_STARTED';
export const LOAD_ROLE_OF = '@@affectli/admin/users/LOAD_ROLE_OF';

export const LOAD_USER_HISTORY_STARTED = '@@affectli/admin/users/LOAD_USER_HISTORY_STARTED';
export const LOAD_USER_HISTORY = '@@affectli/admin/users/LOAD_USER_HISTORY';

export const LOAD_USER_WORKSPACES_STARTED = '@@affectli/admin/users/LOAD_USER_WORKSPACES_STARTED';
export const LOAD_USER_WORKSPACES = '@@affectli/admin/users/LOAD_USER_WORKSPACES';

export const LOAD_USER_ABOUT_WORKSPACES_STARTED = '@@affectli/admin/users/LOAD_USER_ABOUT_WORKSPACES_STARTED';
export const LOAD_USER_ABOUT_WORKSPACES = '@@affectli/admin/users/LOAD_USER_ABOUT_WORKSPACES';

export const SET_USER_DEFAULT_IDENTITY_PROVIDER_STARTED = '@@affectli/admin/users/SET_USER_DEFAULT_IDENTITY_PROVIDER_STARTED';
export const SET_USER_DEFAULT_IDENTITY_PROVIDER = '@@affectli/admin/users/SET_USER_DEFAULT_IDENTITY_PROVIDER';

/**
 * Load the detail of the specified User
 *
 * @param user the name of the User to load
 */
export const loadUser = id => loadData(LOAD_USER_STARTED, LOAD_USER, userByReferenceQuery, addRoleToData)({ id });

/**
 * Fetch the user changelog.
 *
 * @param login the entity login.
 * @param id the entity ID.
 * @param options the filter options.
 */
export const loadUserChangelog = (login, id, options) => dispatch => {
    dispatch({ type: LOAD_USER_HISTORY_STARTED });
    return graphql
        .query({
            query: userChangelogQuery,
            variables: { reference: { login }, id: String(id), ...options },
            fetchPolicy: 'no-cache',
        })
        .then(response => {
            const payload = {
                changes: get(response, 'data.userByReference.changelog'),
                startIndex: options.startIndex,
                count: get(response, 'data.count'),
            };
            dispatch({ type: LOAD_USER_HISTORY, payload });
        })
        .catch(error => {
            dispatch({ type: LOAD_USER_HISTORY, payload: error, error: true });
        });
};

export const loadUserWorkspaces = (userId, options = {}) => {
    const variables = buildUserWorkspaceFilter(userId, options, true);
    return loadData(LOAD_USER_WORKSPACES_STARTED, LOAD_USER_WORKSPACES, loadUserWorkspacesQuery, (payload, meta) => {
        const records = payload.records?.map(wspace => {
            const users = [];
            wspace.teams.forEach(team => team.team?.isSystem && users.push(...(team?.team?.users || [])));
            const result = (users || []).find(usr => usr && usr?.user?.id === userId) || {};
            return { ...wspace, role: result?.role };
        });
        return { ...payload, records, meta };
    })({ ...variables, startIndex: options?.startIndex || 0 });
};

export const loadUserAboutWorkspaces = (userId, options = {}) => {
    const variables = buildUserWorkspaceFilter(userId, options, true);;
    return loadData(
        LOAD_USER_ABOUT_WORKSPACES_STARTED,
        LOAD_USER_ABOUT_WORKSPACES,
        loadUserAboutWorkspacesQuery
    )({ ...variables, startIndex: options?.startIndex || 0 });
};

export const clearUserResourcesList = () => dispatch => {
    dispatch({ type: LOAD_USER_WORKSPACES, payload: null });
};
